// ============================================================
// src/api/authApi.js  –  Login / Logout / Profile
// ============================================================
// Backend: POST /api/auth/login
//          POST /api/auth/logout
//          GET  /api/auth/me
// ============================================================

import { apiFetch, saveToken, clearToken } from './apiConfig';

// POST login with EE# + password + role
// Returns: { token, user: { id, ee_number, first_name, last_name, role } }
export async function login(ee_number, password, role) {
  const res = await apiFetch('/auth/login', {
    method: 'POST',
    body: { ee_number, password, role },
  });
  if (res.token) {
    saveToken(res.token);
    localStorage.setItem('fmcc_user', JSON.stringify(res.user));
  }
  return res;
}

// POST logout — clears token from localStorage
export async function logout() {
  try {
    await apiFetch('/auth/logout', { method: 'POST' });
  } finally {
    clearToken();
  }
}

// Read currently logged-in user from localStorage (no API call)
export function getCurrentUser() {
  const raw = localStorage.getItem('fmcc_user');
  return raw ? JSON.parse(raw) : null;
}
